// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t2-cm","col":"styles_col__3-zRr"};